import { create } from 'apisauce';

const api = create({
  baseURL: 'https://api.truckersmp.com/v2/',
});

export default api;
